import { IconNameV1, IconV1 } from 'common/icon/iconV1.js';

interface ObservationProps {
  name: IconNameV1;
  label: string;
  value?: string | JSX.Element;
}

export const Observation = ({ name, label, value }: ObservationProps) => (
  <div className="Observation">
    <div className="u-flex u-flexAlignItemsCenter u-text-xs">
      <div className={'u-flexGrow-0 u-flex u-flexAlignItemsCenter Observation__icon'}>
        <IconV1 iconClass="u-flex svg-fill-textSlate u-flex-1 svg--1em" icon={name} />
      </div>
      {label}
    </div>
    <div className="Observation__value">{value}</div>
  </div>
);
